export const groupNotsos = (notsos) => {
    if (!notsos || !Array.isArray(notsos)) return [];

    const grouped = new Map();

    // First pass: group by satellite numbers
    notsos.forEach(notso => {
        if (notso.SatNos && notso.SatNos.length > 0) {
            notso.SatNos.forEach(satNo => {
                if (!grouped.has(satNo) || new Date(notso.CreatedAt) > new Date(grouped.get(satNo).CreatedAt)) {
                    grouped.set(satNo, notso);
                }
            });
        } else {
            // For NOTSOs without satellites, use EventClass as key
            if (!grouped.has(notso.EventClass) || new Date(notso.CreatedAt) > new Date(grouped.get(notso.EventClass).CreatedAt)) {
                grouped.set(notso.EventClass, notso);
            }
        }
    });

    // Convert map values to array and remove duplicates
    return Array.from(new Set(grouped.values()));
};

export const hasSatNo = (array) => {
    return parseInt(array?.[0]) >= 0;
};

// Get category type for filtering
export const getCategoryType = (str) => {
    if (!str) return null;
    const lowerStr = str.toLowerCase();
    if (lowerStr.includes('photometry')) return 'photometry';
    if (lowerStr.includes('rpo')) return 'rpo';
    if (lowerStr.includes('maneuver')) return 'maneuver';
    if (lowerStr.includes('launch')) return 'launch';
    return null;
}; 